import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-basket',
  templateUrl: './icon-basket.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBasketComponent {}
